import React from "react";
import { SvgIcon } from "@material-ui/core";

const BicycleIcon = (props) => (
  <SvgIcon {...props}>
    <svg viewBox="0 0 66.061 66.061">
      <g>
        <rect width="66.061" height="66.061" rx="12" ry="12" fill="#044995" />
        <g>
          <path
            d="M60.821,41.439c-.143.438-.311.871-.425,1.316-1.014,3.971-5.063,8.382-11.482,8.031-4.705-.257-9.02-3.979-9.989-8.827-.062-.312-.14-.622-.223-.985h-8.152c1.723-4.825,3.405-9.534,5.129-14.362-.405-.042-.71-.101-1.015-.101-3.546-.006-7.092.016-10.638-.021-.737-.008-1.117.225-1.344.924-.277.854-.66,1.675-1.036,2.607,3.295,2.053,5.334,4.945,5.664,8.859.231,2.728-.489,5.231-2.122,7.449-3.208,4.358-9.156,5.746-13.982,3.265-4.796-2.465-7.096-8.117-5.422-13.299,1.406-4.35,6.203-8.842,13.587-7.212,1.525-3.766,3.059-7.556,4.668-11.528h-5.711v-2.316h9.271c-1.169,2.926-2.32,5.81-3.525,8.826h15.117c-1.729,4.842-3.41,9.547-5.169,14.472,1.537,0,2.958.021,4.377-.028.167-.006.409-.37.47-.606,1.511-5.842,5.567-9.269,11.004-9.196,5.908.08,10.12,4.506,10.781,9.205.013.095.11.179.168.268v3.257ZM42.15,40.982c.467,3.986,4.268,6.906,8.345,6.555,4.029-.347,7.234-4.004,7.073-8.071-.164-4.15-3.786-7.603-7.887-7.52-3.812.077-7.355,3.153-7.469,6.625h7.441v2.411h-7.503ZM18.083,32.26c-4.037-1.061-8.142,1.389-9.299,5.421-1.142,3.983,1.115,8.174,5.111,9.491,3.981,1.312,8.324-.828,9.748-4.802,1.237-3.45-.365-7.908-3.322-9.055-1.094,2.685-2.19,5.373-3.31,8.123-.79-.324-1.478-.606-2.246-.92,1.115-2.775,2.198-5.471,3.317-8.256Z"
            fill="#fff"
          />
          <path
            d="M42.851,19.777q-.528,2.823-3.217,2.823c-1.152,0-2.307-.047-3.456.016-.749.041-1.129-.227-1.306-.938-.154-.62-.388-1.22-.611-1.901h8.59Z"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  </SvgIcon>
);

export default BicycleIcon;
